export default "__VITE_PUBLIC_ASSET__9aff7b48__"